import type { Components } from '@/api/generated/api';

export type SupportMeasureActivity = Components.Schemas.SupportMeasureEntryActivityDto;

export const TIMELINE_ACTIVITY_TYPES: readonly SupportMeasureActivity['type'][] = [
  'studentAdded',
  'studentRemoved',
  'studentEntriesRemoved',
  'competenceAdded',
  'competenceRemoved',
];

/**
 * Whether an activity targets a student or a competence. `activityDirection` alone cannot tell
 * studentRemoved from competenceRemoved, so grouping and labelling both need this.
 */
export const activityTargetKind = (activity: SupportMeasureActivity): 'competence' | 'student' =>
  activity.type === 'studentAdded' || activity.type === 'studentRemoved' || activity.type === 'studentEntriesRemoved'
    ? 'student'
    : 'competence';

export const activityDirection = (activity: SupportMeasureActivity): 'add' | 'entries' | 'remove' => {
  if (activity.type === 'studentAdded' || activity.type === 'competenceAdded') return 'add';
  if (activity.type === 'studentEntriesRemoved') return 'entries';
  return 'remove';
};
